<div class="container p-4"><h3>Opening secure support session…</h3><p *ngIf="error">{{error}}</p></div>